import styled from 'styled-components'

export const BackButtonStyles = {
  Root: styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    html[dir='rtl'] & img {
      transform: scaleX(-1);
    }
  `,
} as const
